module.exports = __webpack_public_path__ + "static/bootstrap-card-pills-2ab517e58f30da46b6b1cdf1fc7b5079.png";